import { Controller } from '@hotwired/stimulus'

export default class DetailsController extends Controller<HTMLElement> {
  initialize() {
    // CommandAPI is baseline 2025, so we should keep a fallback here for a while.
    if (
      'commandfor' in document.createElement('button') === false &&
      !document.documentElement.matches('[data-polyfills~="command-api"]')
    ) {
      this.polyfillCommandAPI()
    }
  }

  handleCommand(event) {
    const command = event.command ?? event.detail?.command
    if (!command) return
    if (command === '--toggle') {
      this.element.open = !this.element.open
    } else if (command === '--show') {
      this.element.open = true
    } else {
      this.element.open = false
    }
  }

  polyfillCommandAPI() {
    const polyfills = document.documentElement.dataset.polyfills?.split(' ') ?? []
    polyfills.push('command-api')
    document.documentElement.dataset.polyfills = polyfills.join(' ')
    document.documentElement.addEventListener('click', event => {
      const trigger = event.target.closest('[command][commandfor]')
      if (!trigger) return
      const target = document.getElementById(trigger.getAttribute('commandfor'))
      if (!target) return
      target.dispatchEvent(new CustomEvent('command', { detail: { command: trigger.getAttribute('command') } }))
    })
  }
}
